export const LANGUAGES = {
  KOREAN: 'ko-KR',
  ENGLISH: 'en-US',
  JAPANESE: 'ja-JP',
  CHINESE: 'zh-CN',
  GERMAN: 'de-DE',
};
export const INIT_LANGUAGE = LANGUAGES.KOREAN;
export const DEFAULT_LANGUAGE = LANGUAGES.ENGLISH;
export const WHITE_LANGUAGES = [LANGUAGES.KOREAN, LANGUAGES.ENGLISH];
export const BLACK_LANGUAGES = [
  LANGUAGES.JAPANESE,
  LANGUAGES.CHINESE,
  LANGUAGES.GERMAN,
];

export const getCountryLang = (t, lang, lng = undefined) => {
  const langKey = lang.toLowerCase().replace('-', '_');
  return lng ? t(langKey, { lng }) : t(langKey);
};
